export default __webpack_public_path__ + "static/media/MosquitoRepellent.b64a9fa4.png";